import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'db0004',
    ecrans: ['00-2',
        '01-2']
});
